import { isTreeField, isTreeTable } from "@/helpers/Misc";
import { XmlHelper } from "@/helpers/Xml";

export default class StructurePreprocessing {
  static normalizeXpaths(structure: IStructure) {
    let sections = window.FormEngine.structure.getAllSectionsArray(structure.tree);
    for (let sectionName in sections) {
      if (sections[sectionName].XpathEdoc) {
        let normalizedXpath = XmlHelper.getNormalizedXpath(sections[sectionName].XpathEdoc);
        let xmlNodeSelector = XmlHelper.getXpathImportSelector(normalizedXpath);
        sections[sectionName].XpathEdoc = normalizedXpath;
        sections[sectionName].XmlNodeSelector = xmlNodeSelector;
      } else {
        sections[sectionName].XpathEdoc = "";
        sections[sectionName].XmlNodeSelector = "";
      }
    }
    let controls = window.FormEngine.structure.getAllControlsArray(structure.tree);
    for (let controlName in controls) {
      if (controls[controlName].XpathEdoc) {
        let normalizedCodeXpath = XmlHelper.getNormalizedXpath(controls[controlName].XpathEdoc);
        let xmlNodeSelector = XmlHelper.getXpathImportSelector(normalizedCodeXpath);
        controls[controlName].XpathEdoc = normalizedCodeXpath;
        controls[controlName].XmlNodeCodeSelector = xmlNodeSelector;
      } else {
        controls[controlName].XpathEdoc = "";
        controls[controlName].XmlNodeCodeSelector = "";
      }

      if (controls[controlName].XpathText) {
        let normalizedXpath = XmlHelper.getNormalizedXpath(controls[controlName].XpathText);
        let xmlNodeCodeSelector = XmlHelper.getXpathImportSelector(normalizedXpath);
        controls[controlName].XpathText = normalizedXpath;
        controls[controlName].XmlNodeSelector = xmlNodeCodeSelector;
      } else {
        controls[controlName].XpathText = "";
        controls[controlName].XmlNodeSelector = "";
      }

    }
  }
  static initFunctionalityPreprocessing(structure: IStructure) {
    for (let funct in structure.functionality) {
      let fu = structure.functionality[funct];
      fu.ExpressionText = fu.ExpressionText.replaceAll("&amp;", "&");
    }
  }
  static initAutocompletes(structure: IStructure) {
    for (let structIndex in structure.ldts) {
      let ldt = structure.ldts[structIndex];
      if (ldt.IsAutocomplete) {
        ldt.FieldType = "Autocomplete";
      }
    }
  }
  // Tables handling
  static initTables(structure: IStructure) {
    let tables = window.FormEngine.structure.filterSections(
      (item: ITreeTable) => item.MaxRepetition && item.MaxRepetition > 1,
      structure.tree
    ) as Array<ITreeTable>;
    //console.log(tables);
    for (let tableName in tables) {
      let table = tables[tableName];
      table.IsTable = true;
      if (!table.ReadOnlyFlag) {
        table.ReadOnlyFlag = true;
      }
      if (!table.CheckboxColumn) {
        table.CheckboxColumn = false;
      }
      table.LDT = {
        FieldType: "Table",
        MinRows: table.MinRepetition as number,
        MaxRows: table.MaxRepetition as number,
      };
      table.Columns = [];
      //console.log(table);
      for (let propName in table.Tree) {
        // ONLY TREEFIELD AND TREESECTION BECASUE TABLE CAN'T HAVE COLUMN AS ANOTHER TABLE !
        let prop = table.Tree[propName] as ITreeField | ITreeSection;
        let columnConfig = {} as IColumnConfig;
        if (isTreeField(prop)) {
          // Tabulkove stlpce sa zozbieraju
          if (prop.XpathEdoc && prop.XmlNodeCodeSelector) {
            columnConfig.xpath = prop.XpathEdoc;
            columnConfig.xpathElementSelector = prop.XmlNodeCodeSelector;
          } else {
            columnConfig.xpath = "";
            columnConfig.xpathElementSelector = "";
          }
          columnConfig.prop = propName;
          columnConfig.text = prop.Name;
          table.Columns.push(columnConfig);
        } else {
          if (prop.MaxRepetition && prop.MaxRepetition > 1) {
            // Tabulkovy stlpec ? - Mozno nieje potrebne
            columnConfig.prop = propName;
            columnConfig.text = prop.Name;
            table.Columns.push(columnConfig);
          } else {
            this.handleDetail(table, propName, prop as ITreeSection);
          }
        }
      }
      if (!table.ValuesToColumnsMapping) {
        this.mapValuesToColumnsMapping(table);
      }
    }
  }
  public static handleDetail(table: ITreeTable, identifier: string, prop: ITreeTable | ITreeSection) {
    // Detail - a prislusny processing
    if (prop.Tree) {
      table.ReadOnlyFlag = false;
      this._walkJSONTreeWith(prop.Tree, function (elementName: string, element: ITreeField | ITreeTable | ITreeSection) {
        element.IsTableDetailElement = true;
        element.ParentTableControl = prop.Parent;
      });
      // for (let dControlName in prop.Tree) {
      //   if (isTreeField(prop.Tree[dControlName]) || isTreeTable(prop.Tree[dControlName])) prop.Tree[dControlName].IsTableDetailElement = true;
      //   prop.Tree[dControlName].ParentTableControl = prop.Parent;
      // }
      table.Detail = prop as ITableDetail;
      table.Detail.Identifier = identifier;
    } else {
      table.Detail = null;
    }
  }

  public static mapValuesToColumnsMapping(table: ITreeTable) {
    if (table.Detail && table.Columns) {
      table.ValuesToColumnsMapping = {};
      let supplementaryIndex = 0;
      this._walkJSONTreeWith(
        table.Detail.Tree,
        function (controlName: string, element: ITreeField | ITreeTable) {
          if (table.Detail && table.Columns) {
            let column = table.Columns.find((col: IColumnConfig) => {
              return element.XpathEdoc !== "" && col.xpath === element.XpathEdoc;
            });
            if (column && column.prop) {
              table.ValuesToColumnsMapping[controlName as string] = column.prop;
            }
            if (table.Columns && table.Columns[supplementaryIndex] && table.Columns[supplementaryIndex].prop) {
              table.ValuesToColumnsMapping[controlName as string] = table.Columns[supplementaryIndex].prop as string;
            }
          }
          supplementaryIndex++;
        },
        (elementName: string, element: any) => {
          return !(element.MaxRepetition && element.MaxRepetition > 1);
        }
      );
    }
  }
  public static initRadioButtonListSections(structure: IStructure) {
    let lookups = structure.lookups ? structure.lookups : {};
    let controls = window.FormEngine.structure.filterControls((item: ITreeField) => {
      let ldtsId = item.FieldLogicalDataTypeID;
      return structure.ldts[ldtsId as string].FieldType == "RadioButtonListSection";
    }, structure.tree) as Array<ITreeField>;
    //console.log(controls);
    for (let rblsIndex in controls) {
      let rbls = controls[rblsIndex];
      let options = lookups[rbls.LookupID as string];
      if (options && !Array.isArray(options)) {
        options = Object.keys(options).map((key: string) => {
          return (options as { [key: string]: ILookup })[key];
        }) as [ILookup];
      }
      if (!rbls.Tree) {
        rbls.Tree = {};
      }
      for (let optionIndex in options) {
        let option = options[optionIndex];
        let section = window.FormEngine.structure.filterSections((item: ITreeField | ITreeSection) => {
          return item.Identifier == rbls.Identifier + "_" + option.Value;
        }, structure.tree) as Array<ITreeSection>;
        if (section[0]) {
          const sec = Object.assign({}, section[0]);
          sec.Parent = rbls.Identifier;
          sec.IsOptionSection = true;
          rbls.Tree[rbls.Identifier + "_" + option.Value] = sec;
          this._removeByIdentifierInTree(structure.tree as ITree, rbls.Identifier + "_" + option.Value, rbls.Identifier);
        }
      }
    }
  }
  public static initOverlays(structure: IStructure) {

  }
  public static initXmlXsltValidationOverlay(structure: IStructure) {

    structure.tree['_XmlXsltValidationProcessOverlayWindow'] = {
      "XpathEdoc": null,
      "MinRepetition": 1,
      "MaxRepetition": 1,
      "PagedSection": null,
      "IsOverlay": true,
      "Identifier": "_XmlXsltValidationProcessOverlayWindow",
      "Name": "Xml validácia s Xsd",
      "HasHiddenCaption": false,
      "Hint": null,
      "Title": null,
      "Parent": "",
      "Rules": {},
      "Tree": {
        "_XmlXsltValidationProcessOverlayWindowList": {
          "XpathEdoc": null,
          "MinRepetition": 1,
          "MaxRepetition": 1,
          "PagedSection": null,
          "Name": "List",
          "Identifier": "_XmlXsltValidationProcessOverlayWindowList",
          "HasHiddenCaption": true,
          "Hint": null,
          "Title": "<h2>Error list</h2>",
          "Parent": "_XmlXsltValidationProcessOverlayWindow",
          "Rules": {},
          "Template": `
          <span v-html="displayDescription"></span>
          <template v-if="additionalData && additionalData.xsdResults">
              <ul  class="idsk-related-content__list govuk-list">
              <li class="idsk-related-content__list-item" v-for="(result,index) in additionalData.xsdResults" :index="index">
              Severity {{result.Severity}} => {{result.Message}}
              </li>
              </ul>
              </template>
          `,
          "Tree": {}
        } as ITreeSection
      },
    } as ITreeSection;
  }
  private static _removeByIdentifierInTree(branch: ITree, identifier: string, ignoreParent: string) {
    for (let id in branch) {
      let prop = branch[id];
      if (id == identifier && ignoreParent != prop.Parent) {
        delete branch[id];
      }
      if (prop.Tree) {
        this._removeByIdentifierInTree(prop.Tree, identifier, ignoreParent);
      }
    }
  }
  // TODO: WALK ONLY TREE WITHOUT CONTROLS CHECKING
  public static _walkJSONTreeWith(
    tree: ITree,
    func: Function,
    nestingConditionFunction: Function = function (elemName: string, elem: any) {
      return true;
    }
  ) {
    for (let elemName in tree) {
      let elem = tree[elemName];
      func(elemName, elem);
      if (nestingConditionFunction(elemName, elem) && elem.Tree) {
        this._walkJSONTreeWith(elem.Tree, func, nestingConditionFunction);
      }
    }
  }
}
